import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getContractList(payload) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/contracts/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: payload });
      const { items, total } = processSuccessResponse(res);

      return { items, total };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientList(payload) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: 'v1/clients/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: payload });
      const { items, total } = processSuccessResponse(res);

      return { items, total };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
